import React from 'react';
import {BrowseCourse} from '@udemy-v2/browse-course';
import {BrowseEventTrackingProvider} from '@udemy-v2/react-browse-event-tracking';
import {ShowMore} from '@udemy-v2/react-reveal-components';
import {Button, ButtonProps} from '@udemy-v2/react-core-components';
import {CondensedBrowseCourseCard} from './components/condensed-browse-course-card';

import styles from './students-also-bought.module.scss';
import classNames from 'classnames';

// Number of courses to display before showing the "Show More" button
const DISPLAYED_COURSES_COUNT = 6;

const ShowMoreButton = (props: ButtonProps) => (
    <Button {...props} udStyle="secondary">
        {props.children}
    </Button>
);

interface StudentsAlsoBoughtProps {
    courses: BrowseCourse[];
    title: string;
}

export const StudentsAlsoBought = ({courses, title}: StudentsAlsoBoughtProps) => {
    // Don't render if no courses found
    if (!courses.length) {
        return null;
    }

    const hiddenCoursesCount = courses.length - DISPLAYED_COURSES_COUNT;
    const courseCards = courses.map((course, idx) => (
        <BrowseEventTrackingProvider
            key={course.id}
            browseEventTrackingContext={{
                index: idx,
            }}
        >
            <CondensedBrowseCourseCard course={course} />
        </BrowseEventTrackingProvider>
    ));

    return (
        <div className={styles.container}>
            <h2 className={classNames(styles['unit-heading'], 'ud-heading-xl')}>{title}</h2>
            {hiddenCoursesCount > 0 ? (
                <ShowMore
                    collapsedHeight={700}
                    fullWidthButton={true}
                    buttonComponent={ShowMoreButton}
                    hideIcons={true}
                    className={styles['show-more']}
                    data-purpose="show-more-container"
                >
                    <div
                        className={styles['grid-container']}
                        data-purpose="show-more-content-container"
                    >
                        {courseCards}
                    </div>
                </ShowMore>
            ) : (
                <div
                    className={styles['grid-container']}
                    data-purpose="short-list-content-container"
                >
                    {courseCards}
                </div>
            )}
        </div>
    );
};
